// extracted by mini-css-extract-plugin
export default {"userMain":"LoadPhoto_userMain__DE1D7","userPhotoBox":"LoadPhoto_userPhotoBox__dcSo5","userImg":"LoadPhoto_userImg__cSo4E","uploadBtn":"LoadPhoto_uploadBtn__EPAhQ"};